import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsGuiaAnaliseApi extends ComponentAPI<{ record: {}, readonly: boolean, hiddenContextMenu: boolean }>{

  @AwesomeEvent
  onInformarParecerClick = new ClickEventListener();

  getRecord(): {} {
    return this.state.record;
  }

  setReadonly(): void {
    this.setState({ readonly: true });
  }

  setHiddenContextMenu(): void {
    this.setState({ hiddenContextMenu: true });
  }

  setSituacao(registro: Record<string, any>): void {
    const { record } = this.state;
    this.setState({ record: { ...record, [registro.nrSequencia]: registro } });
  }
}
